import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const tarefaSlaRepository = createRepository({
  path: 'tarefa-sla',
  restApi
})

tarefaSlaRepository.temposFila = (dataInicio, dataFim, geral, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-aberto-mean-max`, {
    dataInicio,
    dataFim,
    geral,
    empresaId
  })
}

tarefaSlaRepository.temposAnalise = (dataInicio, dataFim, geral, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-analise-mean-max`, {
    dataInicio,
    dataFim,
    geral,
    empresaId
  })
}

tarefaSlaRepository.temposFilaAtual = params => {
  return restApi.get(`tarefa-sla/tarefas-aberto-atual-mean-max`, params)
}

tarefaSlaRepository.temposAnaliseAtual = params => {
  return restApi.get(`tarefa-sla/tarefas-analise-atual-mean-max`, params)
}

tarefaSlaRepository.tarefasTotal = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-total`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.filaAtual = params => {
  return restApi.get('tarefa-sla/tarefas-aberto-atual', params)
}

tarefaSlaRepository.viagensAtual = params => {
  return restApi.get('tarefa-sla/tarefas-viagens-atual', params)
}

tarefaSlaRepository.viagensAtualCount = params => {
  return restApi.get('tarefa-sla/tarefas-viagens-atual/count', params)
}

tarefaSlaRepository.analiseAtual = params => {
  return restApi.get('tarefa-sla/tarefas-analise-atual', params)
}

tarefaSlaRepository.pendenteFilialAtual = params => {
  return restApi.get('tarefa-sla/tarefas-pendente-filial-atual', params)
}

tarefaSlaRepository.pendenteMotoristaAtual = params => {
  return restApi.get('tarefa-sla/tarefas-pendente-motorista-atual', params)
}

tarefaSlaRepository.liberadaComPendenciaAtual = params => {
  return restApi.get('tarefa-sla/tarefas-liberada-pendencia-atual', params)
}

tarefaSlaRepository.tempoPorAnalista = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-mean-max-por-analista`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.tarefasPorAnalista = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-por-analista`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.metasTarefasPorAnalista = (
  dataInicio,
  dataFim,
  empresaId
) => {
  return restApi.get(`tarefa-sla/metas-tarefas-por-analista`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.tempoPorUnidade = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-mean-max-por-unidade`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.tarefasPorUnidade = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-por-unidade`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.metasTarefasPorUnidade = (dataInicio, dataFim) => {
  return restApi.get(`tarefa-sla/metas-tarefas-por-unidade`, {
    dataInicio,
    dataFim
  })
}

tarefaSlaRepository.tarefasPorHora = (dataInicio, dataFim, empresaId) => {
  return restApi.get(`tarefa-sla/tarefas-por-hora`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.tarefasFinalizadasPorHora = (
  dataInicio,
  dataFim,
  empresaId
) => {
  return restApi.get(`/tarefa-sla/tarefas-finalizadas-por-hora`, {
    dataInicio,
    dataFim,
    empresaId
  })
}

tarefaSlaRepository.findTemposOciosos = (dataInicio, dataFim) => {
  return restApi.get('tarefa-sla/tempos-ociosos-analistas', {
    dataInicio,
    dataFim
  })
}

tarefaSlaRepository.logTarefaTempoStatus = tarefaId => {
  return restApi.get(`/tarefa-sla/log-tarefa-tempo-status/${tarefaId}`)
}

tarefaSlaRepository.logTarefaTempoAnalisePorAnalista = tarefaId => {
  return restApi.get(
    `/tarefa-sla/log-tarefas-tempo-analise-por-analista/${tarefaId}`
  )
}

export default tarefaSlaRepository
